import React from 'react'
import { RadialProgress } from '@ztechapps/webui.util'
import { NumberInlineInput } from '@ztechapps/webui.input'
import type { SetOptional } from 'type-fest'
import type { TaskInlineInputProps } from './TaskInlineInput'
import { TaskInlineInput } from './TaskInlineInput'

export type PercentCompleteTaskInlineInputProps = SetOptional<TaskInlineInputProps, 'name'>

export const TaskPercentCompleteInlineInput = ({
  name,
  label,
  help,
  inputProps,
  parentInputComponent,
  displayContent,
  ...props
}: PercentCompleteTaskInlineInputProps) => {
  const ParentInput = parentInputComponent || TaskInlineInput

  displayContent = displayContent || ((v) => <RadialProgress value={v} size={30} strokeWidth={2} />)

  return (
    <ParentInput
      name={name ?? 'percentageComplete'}
      label={label ?? '% Complete'}
      help={help ?? 'The estimate of user for the task percentage before completion'}
      displayContent={displayContent}
      parentInputComponent={NumberInlineInput}
      inputProps={
        inputProps ?? {
          min: 0,
          max: 100,
          step: 10,
        }
      }
      {...props} //because we defined it here at the bottom all other props on the top will be overridden if they are also defined
    />
  )
}
